import { render, staticRenderFns } from "./BankSoalTableActive.vue?vue&type=template&id=31b955b6&scoped=true"
import script from "./BankSoalTableActive.vue?vue&type=script&lang=js"
export * from "./BankSoalTableActive.vue?vue&type=script&lang=js"
import style0 from "./BankSoalTableActive.vue?vue&type=style&index=0&id=31b955b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b955b6",
  null
  
)

export default component.exports